import React, { useState, useEffect } from "react";
import { fetchUserData } from "../Utils/api";

const Location = ({ userName }) => {
  const [data, setdata] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const getData = async () => {
      try {
        const result = await fetchUserData(userName);
        setdata(result[0]);
      } catch (error) {
        console.log("error fetching data in location", error);
      } finally {
        setLoading(false);
      }
    };
    getData();
  }, [userName]);

  const address = data?.address || "Bahrain"; // Fallback to Bahrain
  const googleMapUrl = `https://www.google.com/maps?q=${encodeURIComponent(
    address
  )}&output=embed`;

  if (loading)
    return <p style={{ textAlign: "center", padding: "10px" }}>Loading...</p>;

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "10px",
        paddingBottom: "20px",
      }}
    >
      <iframe
        title="Google Maps Location"
        src={googleMapUrl}
        width="100%"
        height="250px"
        allowFullScreen=""
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        style={{ border: "none" }}
      ></iframe>
    </div>
  );
};

export default Location;
